import React from 'react'
import {
  Dialog,
  Unstable_Grid2 as Grid,
  DialogTitle,
  DialogContent,
  ButtonBase,
} from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Close } from '@mui/icons-material'

const useStyles = makeStyles()((theme) => {
  return {
    paper: {
      borderRadius: 0,
    },
    dialogHeader: {
      fontSize: theme.typography.pxToRem(28),
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(8, 8, 0, 8),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(30),
    },
    dialogBody: {
      padding: theme.spacing(4, 8),
      fontSize: theme.typography.pxToRem(16),
    },
  }
})

const Modal = ({ open, setModalOpen, bodyContent, headerContent }) => {
  const { classes } = useStyles()

  return (
    <Dialog open={open} maxWidth="md" classes={{ paper: classes.paper }}>
      <Grid container>
        <DialogTitle classes={{ root: classes.dialogHeader }}>
          {headerContent}
          <ButtonBase onClick={() => setModalOpen(false)}>
            <Close classes={{ root: classes.closeIcon }} />
          </ButtonBase>
        </DialogTitle>
        <DialogContent classes={{ root: classes.dialogBody }}>
          <Grid container>{bodyContent}</Grid>
        </DialogContent>
      </Grid>
    </Dialog>
  )
}

export default Modal
